import { Modal, Button } from 'react-bootstrap-v5'

export const ConfirmModal = ({ show, onClose, onConfirm, items }: any) => (
    <Modal show={show} onHide={onClose} centered
        size="lg" // This makes the modal wider
    >
        <Modal.Header>
            <Modal.Title>Add Recommended Items?</Modal.Title>
            <button type='button' className='btn-close' onClick={onClose}></button>
        </Modal.Header>
        <Modal.Body>
            <p>You've selected screws. These are often used together with plates and washers for a complete
                setup. Would you like to add them to your order?</p>
            {/* <ul>
                {items.map((item: any) => (
                    <li key={item.id}>{item.name} (Qty: {item.quantity})</li>
                ))}
            </ul> */}
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
            {/* <Button
                variant="light"
                onClick={onClose}
                className="me-auto" // This pushes the 'Cancel' button to the far left, keeping others right
            >
                Cancel
            </Button> */}

            <Button
                variant="secondary"
                className="me-2"
                onClick={() => onConfirm(false)}
            >
                No, Just Screws
            </Button>

            <Button
                variant="primary"
                onClick={() => onConfirm(true)}
            >
                Yes, Add Items
            </Button>
        </Modal.Footer>
    </Modal>
)